import React, { Component } from "react";
import { Button, SelectBox } from "devextreme-react";
import { SelectBoxOnValueChangedEvent } from "../../types/DevExtremeTypes";
import { ID_CHECK_NO_SERVICES_FILTER } from "../../services/IDChecksService";

interface IDChecksSidePanelProps {
    onApplyButtonClick: (idCheckStatusId: string, serviceFilter: string) => void;
     
    serviceOptions: string[];
}

interface IDChecksSidePanelState {
    disableApplyButton: boolean;
    statusTypeList: Array<{ id: string; value: string }>;
    idCheckStatusId: string;
     
    serviceFilter: string;
}

class IDChecksSidePanel extends Component<IDChecksSidePanelProps> {
    state: IDChecksSidePanelState;

    constructor(props: IDChecksSidePanelProps) {
        super(props);
        this.state = {
            disableApplyButton: false,
            statusTypeList: [
                { id: "", value: "All" },
                { id: "5", value: "Requested" },
                { id: "10", value: "Requires Review" },
                { id: "2", value: "Approved" },
                { id: "99", value: "Rejected" }
            ],
            idCheckStatusId: "",
            serviceFilter: ""
        };
    }

     
    /**
     * Updates selected ID checks status filter.
     */
    handleChangeStatusTypeChange = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            idCheckStatusId: dxValueChange.value
        });
    };

     
     
    /**
     * Updates the selected local services filter (applied client-side only).
     */
    handleServiceFilterChange = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            serviceFilter: dxValueChange.value ?? ""
        });
    };

     
    /**
     * Builds the services dropdown items from the services present in the loaded grid data.
     * Keeps the current selection in the list so it remains visible after a status reload.
     */
    getServiceFilterList = (): Array<{ id: string; value: string }> => {
        const options = [...this.props.serviceOptions];
        const selected = this.state.serviceFilter;
        if (selected && selected !== ID_CHECK_NO_SERVICES_FILTER && !options.includes(selected)) {
            options.push(selected);
        }
        return [
            { id: "", value: "All" },
            { id: ID_CHECK_NO_SERVICES_FILTER, value: "No Services" },
            ...options.map((service) => ({ id: service, value: service }))
        ];
    };

    /**
     * Pushes selected status and services filters to the parent page.
     */
    onApplyButtonClicked = () => {
        this.props.onApplyButtonClick(this.state.idCheckStatusId, this.state.serviceFilter);
    };

    render() {
        return (
            <div>
                <div className="row mt-4">
                    <div className="col-10">
                        <h4 className="sidebar__heading font-weight-bold">Filter</h4>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col sidebar__heading">ID Check Status</div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <SelectBox
                            dataSource={this.state.statusTypeList}
                            displayExpr="value"
                            valueExpr="id"
                            onValueChanged={this.handleChangeStatusTypeChange}
                            value={this.state.idCheckStatusId}
                        />
                    </div>
                </div>
                
                <div className="row mt-3">
                    <div className="col sidebar__heading" id="idChecksServicesLabel">Services</div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <SelectBox
                            dataSource={this.getServiceFilterList()}
                            displayExpr="value"
                            valueExpr="id"
                            searchEnabled={true}
                            onValueChanged={this.handleServiceFilterChange}
                            value={this.state.serviceFilter}
                            inputAttr={{ "aria-labelledby": "idChecksServicesLabel" }}
                        />
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-6 mx-auto">
                        <Button
                            className="btn btn-primary btn--large"
                            disabled={this.state.disableApplyButton}
                            onClick={this.onApplyButtonClicked}
                        >
                            Apply
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default IDChecksSidePanel;
